import { useTranslation } from 'react-i18next';
import React, {useState, useEffect} from "react";
import { useAtom } from "jotai";
import { unreadCoachChatsAtom } from "../../jotai_state";
import Api from "../../services/Api";
import {useNavigate} from "react-router";
import { User } from "flowbite-react-icons/outline";
import {getLanguage} from "../../lang/helpers";
import {formatSoon} from "../../helpers/dateFunctions";

interface ChatInterface {
  text: string
  date: string
  unread: boolean
}
interface ClientChatInterface {
  id: string
  firstName: string
  lastName: string
  picture: string
  chat: ChatInterface
}


export default function ChatsPage() {

  const api = Api.getInstance();
  const translation = useTranslation();
  const { t, i18n } = translation;
  const lang = getLanguage(i18n.language);
  const navigate = useNavigate();
  const [clients, setClients] = useState<Array<ClientChatInterface>>([]);
  const [unreadChats, setUnreadChats] = useAtom(unreadCoachChatsAtom);
  const [loaded, setLoaded] = useState<boolean>(false)

  useEffect(() => {
    api.get('coach/chats').then((result) => {
      setClients(result.json.clients)
      setLoaded(true)
    })
  }, [])

  return (
    <div className="main-content">
      <h2 className="mt-4 text-2xl font-medium">Chat</h2>

      {
        loaded ? (
          <div className="mt-2">
            {
              clients.map((client, idx) => {
                let text = client.chat.text
                if (text === '_added_') {
                  if (lang === 'sv') {
                    text = 'Starta din konversation med ' + client.firstName + '...'
                  } else {
                    text = 'Start your conversation with ' + client.firstName + '...'
                  }
                }
                const unreadChat = unreadChats.indexOf(client.id) > -1;
                return (
                  <div key={"client_" + idx} className="mt-4 flex justify-between items-center">
                    <div className="cursor-pointer flex items-center"
                         onClick={() => navigate('/chats/' + client.id)}>
                      {client.picture ? (
                        <img className="picture" alt="pic" src={client.picture}/>
                      ) : (
                        <User className="picture" aria-hidden="true"/>
                      )}
                      <div className="ml-2">
                        <div className="flex">
                          <div className="font-medium">{client.firstName} {client.lastName}</div>
                          <div className="ml-3 text-neutral-400 text-sm">{formatSoon(client.chat.date, lang)}</div>
                        </div>
                        <div className="text-neutral-400 truncate max-w-[400px]">
                          {text}
                        </div>
                      </div>
                    </div>

                    <div className="w-6 text-center">
                      {
                        unreadChat &&
                        <div className="rounded-full h-2 w-2 bg-cherry-500"/>
                      }
                    </div>
                  </div>
                )
              })
            }
            {
              clients.length === 0 &&
                <div className="mt-4">
                  {lang === 'sv' ? 'Här visas de klienter som valt dig': 'Here you will see the clients who selected you'}
                </div>
            }
          </div>
        ) : (
          <div className="mt-4">Loading client chats...</div>
        )
      }
    </div>
  )
}